(function () {
  var DESKTOP_QUERY = '(min-width: 768px)';
  var PRODUCT_CAROUSEL_SELECTOR = 'xo-product[xo-product-information] xo-carousel[xo-name="product-information-desktop"]';
  var CAROUSEL_LIST_SELECTOR = PRODUCT_CAROUSEL_SELECTOR + ' xo-carousel-list';
  var desktopQuery = window.matchMedia(DESKTOP_QUERY);

  function isDesktop() {
    return desktopQuery.matches;
  }

  function isInsideProductMediaList(event) {
    if (!isDesktop()) {
      return false;
    }

    // Não interferir nos cliques das miniaturas — senão o primeiro clique é
    // engolido e é preciso clicar 2x para trocar a imagem principal.
    if (event.target.closest('xo-carousel-thumbnail')) {
      return false;
    }

    return event.target.closest(CAROUSEL_LIST_SELECTOR);
  }

  function stopDesktopDrag(event) {
    var list = isInsideProductMediaList(event);

    if (!list) {
      return;
    }

    list.isThumbMoving = false;
    event.stopPropagation();
  }

  function stopDesktopHorizontalWheel(event) {
    if (!isDesktop() || Math.abs(event.deltaX) <= Math.abs(event.deltaY)) {
      return;
    }

    if (event.target.closest(PRODUCT_CAROUSEL_SELECTOR)) {
      event.stopPropagation();
    }
  }

  function preventNativeImageDrag(event) {
    if (isInsideProductMediaList(event)) {
      event.preventDefault();
    }
  }

  document.addEventListener('mousedown', stopDesktopDrag, true);
  document.addEventListener('touchstart', stopDesktopDrag, true);
  document.addEventListener('dragstart', preventNativeImageDrag, true);
  document.addEventListener('wheel', stopDesktopHorizontalWheel, { capture: true, passive: true });

  // --- Correção do "clique duplo" nas miniaturas (principalmente no mobile) ---
  // O carousel só troca a imagem no clique da miniatura quando isThumbMoving === false.
  // Um toque na tira de miniaturas pode deixar isThumbMoving = true e o reset atrasar,
  // fazendo o 1º toque ser ignorado. Aqui, num toque genuíno (sem arraste), forçamos
  // isThumbMoving = false ANTES do handler do componente, sem afetar o scroll da tira.
  var THUMB_MOVE_THRESHOLD = 10;
  var touchStartX = 0;
  var touchStartY = 0;
  var touchMoved = false;

  function onThumbTouchStart(event) {
    var point = event.touches && event.touches[0] ? event.touches[0] : event;
    touchStartX = point.clientX;
    touchStartY = point.clientY;
    touchMoved = false;
  }

  function onThumbTouchMove(event) {
    var point = event.touches && event.touches[0] ? event.touches[0] : event;
    if (
      Math.abs(point.clientX - touchStartX) > THUMB_MOVE_THRESHOLD ||
      Math.abs(point.clientY - touchStartY) > THUMB_MOVE_THRESHOLD
    ) {
      touchMoved = true;
    }
  }

  function unlockThumbClick(event) {
    if (touchMoved) {
      return; // foi arraste/scroll da tira, não seleciona
    }

    var slide = event.target.closest('xo-carousel-slide');
    if (!slide || !slide.closest('xo-carousel-thumbnail')) {
      return;
    }

    var list = slide.closest('xo-carousel-list');
    if (list) {
      list.isThumbMoving = false;
    }
  }

  document.addEventListener('touchstart', onThumbTouchStart, true);
  document.addEventListener('touchmove', onThumbTouchMove, true);
  document.addEventListener('click', unlockThumbClick, true);
})();
